/**
 * Get price direction by comparing previous and current prices (tick-to-tick).
 * Used for indicators like Last Price where we want to show if price is ticking up/down.
 */
export function getPriceDirectionFromPrices(previousPrice, currentPrice) {
    if (previousPrice === undefined || currentPrice === undefined)
        return 'unchanged';
    if (previousPrice < currentPrice)
        return 'up';
    if (previousPrice > currentPrice)
        return 'down';
    return 'unchanged';
}
/**
 * Get direction based on sign of the value (positive/negative).
 * Used for change indicators where positive = green, negative = red.
 */
export function getDirectionFromSign(value) {
    if (value === undefined)
        return 'unchanged';
    if (value > 0)
        return 'up';
    if (value < 0)
        return 'down';
    return 'unchanged';
}
export const PriceDirectionColorMap = {
    up: 'text-jade-450',
    down: 'text-ember-450',
    unchanged: 'text-white',
};
